/**
 * The match score's vocabulary (lib/inbox/ai/reply-match.ts), as plain
 * values so the settings and replay pages can show it.
 */

/** What can differ between the draft and the sent reply. */
export const MATCH_DIFFERENCES = [
  "wrong_fact",
  "missing_info",
  "extra_info",
  "different_action",
  "tone_length",
] as const;

export type MatchDifference = (typeof MATCH_DIFFERENCES)[number];

export const MATCH_DIFFERENCE_LABELS: Record<MatchDifference, string> = {
  wrong_fact: "Wrong fact",
  missing_info: "Missing info",
  extra_info: "Extra info",
  different_action: "Different action",
  tone_length: "Tone / length only",
};

export type ReplyMatch = {
  /** 1-5: 5 the same answer, 1 a different or contradicting one. */
  score: number;
  differences: MatchDifference[];
  reason: string;
};

/** Stored differences as the app uses them; unknown ones are dropped. */
export const differencesFrom = (value: unknown): MatchDifference[] =>
  Array.isArray(value)
    ? value.filter((d): d is MatchDifference =>
        (MATCH_DIFFERENCES as readonly string[]).includes(d),
      )
    : [];
